var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4135",
    "data-name": "Group 4135",
    transform: "translate(-432 -887.996)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1042",
    "data-name": "Ellipse 1042",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(432 887.996)",
    fill: "#baf639"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chats-fill",
    transform: "translate(454.282 910.049)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1661",
    "data-name": "Rectangle 1661",
    width: 28,
    height: 28,
    transform: "translate(-0.283 -0.053)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9689",
    "data-name": "Path 9689",
    d: "M46.837,39.027a1.759,1.759,0,0,0-1.757-1.757H41.567V33.757A1.759,1.759,0,0,0,39.81,32H25.757A1.759,1.759,0,0,0,24,33.757V47.811a.878.878,0,0,0,1.431.683l3.84-3.1v3.3a1.759,1.759,0,0,0,1.757,1.757H41.3l4.1,3.318a.878.878,0,0,0,1.431-.683Zm-4.672,9.857a.878.878,0,0,0-.552-.2H31.027V45.176H39.81a1.759,1.759,0,0,0,1.757-1.757V39.027H45.08V51.241Z",
    transform: "translate(-21.701 -29.033)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterview);
export default __webpack_public_path__ + "static/media/interview.1448c8ce4c430361d54eaf30bb2ff5f9.svg";
export { ForwardRef as ReactComponent };